module.exports = __webpack_public_path__ + "img/mariela-garcia-dominguez-byn.4fc29e6f.jpg";